export const GenericErrorMessage = "There was an issue with your request. Please try again."
export const UserInfoUpdateMessage = "Your data has been successfully updated."
